import { EnvVariables } from '@/services/EnvService'

const getRedirectUri = () => window.location.origin + '/callback'
const getLogoutRedirectUri = () => window.location.origin + '/' // must be an allowed oauth logout url

const getLogoutUrl = (envVars: EnvVariables) => {
  const logout_Url = envVars.ANALYZE_OAUTH2_LOGOUT_URL
  const logoutUrl = new URL(logout_Url)
  logoutUrl.searchParams.set('logout_uri', getLogoutRedirectUri())
  return logoutUrl.toString()
}

export const getOidcSettings = (envVars: EnvVariables) => ({
  authority: envVars.ANALYZE_OAUTH2_AUTHORIZE_URL,
  responseType: envVars.ANALYZE_Response_Type,
  scope: envVars.ANALYZE_OAUTH2_SCOPES,
  client_id: envVars.ANALYZE_OAUTH2_CLIENT_ID,
  redirect_uri: getRedirectUri(),
  post_logout_redirect_uri: getLogoutRedirectUri(),
  loadUserInfo: false,
  automaticSilentRenew: true,
  metadata: {
    authorization_endpoint: envVars.ANALYZE_OAUTH2_AUTHORIZE_URL,
    token_endpoint: envVars.ANALYZE_OAUTH2_TOKEN_URL,
    end_session_endpoint: getLogoutUrl(envVars),
  },
})
